import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'gg-brand-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <img
      src="/images/logo.webp"
      alt="GuestGenie"
      [style.height.px]="size()"
      style="display:block;width:auto;max-width:100%;cursor:pointer"
    />
  `,
})
export class BrandLogoComponent {
  readonly size = input(18);
}
